// Existing root interview rows also own the project story. Child interviews keep
// their independent transcripts/cuts; no destructive data migration is needed.
export const projectIdFor = row => row?.data.collectionId || row?.id || null;
export function projectInterviews(rows, rootId) {
  return rows.filter(row => (row.id === rootId && !row.source_detached) || row.data.collectionId === rootId)
    .sort((a,b) => a.id === rootId ? -1 : b.id === rootId ? 1 : a.id.localeCompare(b.id));
}
// One pass to group interviews for the project library. Same root-first,
// child-id ordering as projectInterviews, but without a full scan per tile.
export function indexProjectInterviews(rows) {
  const byProject=new Map();
  for(const row of rows){
    const rootId=projectIdFor(row);
    if(!rootId || (row.id===rootId && row.source_detached))continue;
    if(!byProject.has(rootId))byProject.set(rootId,[]);
    byProject.get(rootId).push(row);
  }
  for(const [rootId,interviews] of byProject){
    interviews.sort((a,b)=>a.id===rootId?-1:b.id===rootId?1:a.id.localeCompare(b.id));
  }
  return byProject;
}
export function interviewStatus(row, {processingId, processingText, activeId, localProject} = {}) {
  if (row.id === processingId) return processingText || 'Transcribing…';
  if (!row.media_ready) return 'Upload incomplete';
  const data = row.id === activeId && localProject ? localProject : row.data;
  if (!data.words?.length) return data.transcriptionError ? 'Transcription failed · Retry' : 'Ready to transcribe';
  return `${data.words.length} words · Ready`;
}
export function appendEarlierStory(paper = {sources:{},blocks:[]}, earlier) {
  if (!earlier?.blocks?.length) return paper;
  const existing = new Set(paper.blocks.map(b => b.id));
  return {...paper, sources:{...earlier.sources,...paper.sources}, blocks:[...paper.blocks,...earlier.blocks.filter(b=>!existing.has(b.id))]};
}
export async function loadWorkspaceRow(store, id, interview = false) {
  const row = await store.get(id);
  return !interview && row.data.collectionId ? store.get(row.data.collectionId) : row;
}

/**
 * Protect project integrity: deleting a root with child interviews would strand
 * their collection, and deleting a referenced video would break paper-edit clips.
 * The hosted media itself is removed by the cloud project store after confirmation.
 */
export function interviewDeletionBlocker(rows,row){
  if(rows.some(item=>item.data.collectionId===row.id)){
    return 'This is the main project video. Delete the additional interviews first, then delete the project and its video.';
  }
  if(rows.some(item=>item.id!==row.id && (
    item.data.paperEdit?.blocks?.some(block=>block.sourceId===row.id) ||
    item.data.paperEdit?.assemblyCuts?.items?.some(cut=>cut.snapshot?.blocks?.some(block=>block.sourceId===row.id))
  ))){
    return 'This interview is used in a paper edit (possibly an alternate Assembly cut). Remove its passages from all cuts before deleting the video.';
  }
  return null;
}
